import { mergeMap, Observable, of } from 'rxjs';

export function filterMap<T, R>(fn: (value: T) => R | undefined): (source: Observable<T>) => Observable<R> {
	return (source) =>
		source.pipe(
			mergeMap((value) => {
				const result = fn(value);
				return result === undefined ? of() : of(result);
			}),
		);
}
